import { useMemo } from 'react';

import { Grid, Typography } from '@mui/material';

import { MetaTags } from '@redwoodjs/web';

import TableList from 'src/components/TableList/TableList';
import { DEFAULT_BORDER, PARTNER_SHOPS_TABLE_HEADERS } from 'src/constants';
import { FilterOptionsType } from 'src/utils/tableUtils';

const ViewPartnerShopPage = () => {
    const filterOptions = () => {
        return Object.fromEntries([
            ['Shop Name', []],
            ['Date Created', []],
            ['Status', []],
        ]) as FilterOptionsType;
    };

    // Handle add merchant
    const handleAddRecord = () => {
        // TODO: to be implemented
    };

    const tableData = useMemo(() => {
        return [];
    }, []);

    const handleViewShop = () => {
        // TODO: to be implemented
    };

    return (
        <>
            <MetaTags title="Shops" description="Partner Shops Page" />

            <Grid container sx={{ gap: '24px' }}>
                <Grid
                    item
                    xs={12}
                    sx={{
                        ...DEFAULT_BORDER,
                        height: '116px',
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '8px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B' }}>
                        Partner Shops
                    </Typography>
                    <Typography>
                        Add, View, Remove and Update NPI Partner Shops as necessary
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {/*TODO: Display loader if data is still fetching */}
                    <TableList
                        addRecordButtonText="Add Partner Shop"
                        data={tableData}
                        headers={PARTNER_SHOPS_TABLE_HEADERS}
                        title="Partner Shops List"
                        addRecordCallBack={handleAddRecord}
                        handleViewRecord={handleViewShop}
                        deleteRecordCallBack={() => {}}
                        enableFilter
                        enableExport
                        filterOptions={filterOptions()}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ViewPartnerShopPage;
